module.exports = __webpack_public_path__ + "static/media/step-solution5.14c68120.svg";